(function () {
  if (window.LavishCart) return;

  var cfgEl = document.getElementById('lvk-config');
  var el = document.getElementById('lvk');
  if (!cfgEl || !el) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  C.fallback = (C.fallback || []).filter(Boolean);
  /* Texte kommen aus dem Block (Liquid, sprachabhängig); englischer Fallback nur falls etwas fehlt */
  function t(k, fb) { return (C.t && C.t[k]) || fb; }

  if (el.parentNode !== document.body) document.body.appendChild(el);

  var $ = function (s) { return el.querySelector(s); };
  var itemsEl = $('[data-lvk-items]'), emptyEl = $('[data-lvk-empty]'), footEl = $('[data-lvk-foot]');
  var recsEl = $('[data-lvk-recs]'), trackEl = $('[data-lvk-track]');
  var shipEl = $('[data-lvk-ship]'), shipText = $('[data-lvk-shiptext]'), bar = $('[data-lvk-bar]');
  var totalEl = $('[data-lvk-total]'), discEl = $('[data-lvk-disc]'), countEl = $('[data-lvk-count]');
  var titleEl = $('[data-lvk-titletext]'), countWrap = $('.lvk__countwrap'), gridEl = $('[data-lvk-grid]'), gridDone = false;
  var cart = C.cart, lastFocus = null, recsFor = null, busy = false;

  var nativeFetch = window.fetch.bind(window);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    /* Geldformat wie es Shopify serverseitig für die aktuelle Sprache/Währung ausgibt (siehe snippets/lavish-core) */
    if (window.LVI && window.LVI.fmt) { var lv = window.LVI.fmt(cents); if (lv) return lv; }
    var fmt = C.moneyFormat || '€{{amount_with_comma_separator}}';
    function num(n, dec, t, d) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return s[1] ? s[0] + d + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return num(cents, 2, ',', '.');
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return num(cents, 2, "'", '.');
      return num(cents, 2, '.', ',');
    });
  }

  function img(url, w) {
    if (!url) return '';
    if (typeof url === 'object') url = url.src || url.url || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* srcset: Browser lädt nur so groß wie nötig (schwache Geräte/Netz) */
  function srcset(url, ws) {
    return ws.map(function (w) { return img(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* Schwaches Netz: Anfrage bricht nach 15 s (Lesen) bzw. 30 s (Ändern) ab, statt den Warenkorb minutenlang zu blockieren.
     Netzwerk-/Serverfehler ohne JSON zeigen den normalen Fehlertext statt technischer Browser-Meldungen. */
  function api(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Lavish-Cart': '1' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    var ac = window.AbortController ? new AbortController() : null, tm = 0;
    if (ac) { opts.signal = ac.signal; tm = setTimeout(function () { ac.abort(); }, body ? 30000 : 15000); }
    var fail = function () { return new Error(t('error', 'Error')); };
    return nativeFetch(url, opts).then(function (r) {
      return r.json().catch(function () { throw fail(); }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || t('error', 'Error'));
        return j;
      });
    }, function () { throw fail(); }).then(function (j) { clearTimeout(tm); return j; }, function (e) { clearTimeout(tm); throw e; });
  }

  function refresh() {
    return api(C.rootUrl.replace(/\/$/, '') + '/cart.js').then(function (c) { cart = c; render(); return c; });
  }

  function syncBubble() {
    var n = cart ? cart.item_count : 0;
    document.querySelectorAll('cart-icon').forEach(function (i) {
      try { i.renderCartBubble && i.renderCartBubble(n, false); } catch (e) {}
    });
    if (countEl) countEl.textContent = n;
  }

  /* Versandkosten (Schätzung) aus dem Text der Einstellung, z. B. "5,90 €" (de) oder "€5.90" (en) -> 590 Cent.
     Letztes Komma/Punkt mit 1-2 Ziffern dahinter = Dezimalstellen, alles davor = Tausendertrenner. */
  function shipCents() {
    var s = String(C.shipCost || '').replace(/[^0-9,.]/g, '');
    if (!s) return 0;
    var m = s.match(/^(.*)[.,]([0-9]{1,2})$/);
    var n = m ? parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]) : parseFloat(s.replace(/[.,]/g, ''));
    return isFinite(n) ? Math.round(n * 100) : 0;
  }

  /* null = unbekannt (anderes Land / nicht eingestellt), sonst Cent-Betrag (0 = kostenlos) */
  function shipAdd(total) {
    var local = !C.shipCountry || !C.country || C.country === C.shipCountry;
    if (!C.shipCost || !local) return null;
    if (C.threshold > 0 && total >= C.threshold) return 0;
    return shipCents();
  }

  function renderShipCost(total) {
    /* Zeile „Versand“ im Warenkorb: DE unter der Grenze = Preis (z. B. 5,90 €), ab der Grenze = „Kostenlos“ */
    var costEl = el.querySelector('[data-lvk-shipcost]');
    if (!costEl) return;
    if (costEl.__note == null) costEl.__note = costEl.textContent;
    var local = !C.shipCountry || !C.country || C.country === C.shipCountry;
    if (!C.shipCost || !local) { costEl.textContent = costEl.__note; return; }
    costEl.textContent = (C.threshold > 0 && total >= C.threshold) ? (C.shipFree || costEl.__note) : C.shipCost;
  }

  function renderShip() {
    renderShipCost(cart ? cart.total_price : 0);
    if (!C.threshold || C.threshold <= 0) { shipEl.hidden = true; return; }
    shipEl.hidden = false;
    var total = cart ? cart.total_price : 0;
    var rest = C.threshold - total;
    if (rest > 0) {
      shipEl.classList.remove('is-done');
      shipText.innerHTML = esc(C.barText).replace('[amount]', '<strong>' + esc(money(rest)) + '</strong>');
    } else {
      shipEl.classList.add('is-done');
      shipText.textContent = C.barDone;
    }
    bar.style.width = (total > 0 ? Math.max(4, Math.min(100, (total / C.threshold) * 100)) : 0) + '%';
  }

  function renderItems() {
    var items = (cart && cart.items) || [];
    var empty = items.length === 0;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    el.classList.toggle('is-empty', empty);
    if (titleEl) titleEl.textContent = empty ? (C.emptyTitle || C.title) : C.title;
    if (countWrap) countWrap.hidden = empty;
    if (empty && el.classList.contains('is-open')) renderGrid();
    itemsEl.innerHTML = items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return '<p class="lvk__opt">' + esc(o.name) + ': ' + esc(o.value) + '</p>'; }).join('');
      var orig = it.original_line_price > it.final_line_price ? '<s>' + esc(money(it.original_line_price)) + '</s>' : '';
      var ld = (it.line_level_discount_allocations || []).map(function (d) {
        return '<p class="lvk__lindisc">' + esc(d.discount_application && d.discount_application.title || C.discountLabel) + ' (−' + esc(money(d.amount)) + ')</p>';
      }).join('');
      return '<div class="lvk__item" data-key="' + esc(it.key) + '">' +
        '<a class="lvk__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" srcset="' + esc(srcset(it.image, [100, 200, 300])) + '" sizes="88px" alt="' + esc(it.product_title) + '" width="88" height="110" loading="eager" decoding="async">' : '') + '</a>' +
        '<div><a class="lvk__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + opts + ld +
        '<div class="lvk__qtyrow"><div class="lvk__qty">' +
        '<button type="button" class="lvk__qbtn" data-q="-1" aria-label="' + esc(t('less', 'Fewer')) + '">−</button>' +
        '<span class="lvk__qval">' + it.quantity + '</span>' +
        '<button type="button" class="lvk__qbtn" data-q="1" aria-label="' + esc(t('more', 'More')) + '">+</button></div>' +
        '<button type="button" class="lvk__rm" data-rm>' + esc(C.removeLabel) + '</button></div></div>' +
        '<div class="lvk__price">' + orig + esc(money(it.final_line_price)) + '</div></div>';
    }).join('');
  }

  function renderTotals() {
    /* Gesamt = Warenwert + Versand (Schätzung für DE; andere Länder: Versand wird an der Kasse berechnet) */
    var base = cart ? cart.total_price : 0;
    var add = shipAdd(base);
    totalEl.textContent = money(base + (add || 0));
    var note = el.querySelector('[data-lvk-totalnote]');
    if (note) {
      if (add === null) note.textContent = t('noteUnknown', '(incl. VAT, plus shipping)');
      else if (add === 0) note.textContent = t('noteFree', '(incl. VAT, free shipping)');
      else note.textContent = t('noteIncl', '(incl. VAT & shipping)');
    }
    var cd = (cart && cart.cart_level_discount_applications) || [];
    if (cd.length) {
      discEl.hidden = false;
      discEl.innerHTML = cd.map(function (d) {
        return '<span>' + esc(d.title || C.discountLabel) + '</span><span>−' + esc(money(d.total_allocated_amount)) + '</span>';
      }).join('');
    } else {
      discEl.hidden = true;
      discEl.innerHTML = '';
    }
  }

  function render() {
    renderShip();
    renderItems();
    renderTotals();
    syncBubble();
    if (el.classList.contains('is-open')) loadRecs();
  }

  function renderGrid() {
    if (gridDone || !gridEl) return;
    gridDone = true;
    /* Im Drawer sofort laden (lazy zeigte 1–2 s leere Kästen); nur weiter unten liegende Karten lazy */
    gridEl.innerHTML = C.fallback.slice(0, C.emptyLimit || 8).map(function (p, gi) {
      var price = (p.compare > p.price ? '<s>' + esc(money(p.compare)) + '</s>' : '') + esc(money(p.price));
      return '<a class="lvk__gcard" href="' + esc(p.url) + '">' +
        '<span class="lvk__gimg">' + (p.image ? '<img src="' + esc(img(p.image, 400)) + '" srcset="' + esc(srcset(p.image, [300, 400, 600])) + '" sizes="(min-width: 750px) 220px, 50vw" alt="' + esc(p.title) + '" width="250" height="312" loading="' + (gi < 4 ? 'eager' : 'lazy') + '" decoding="async">' : '') +
        (p.isNew && C.newLabel ? '<span class="lvk__gbadge">' + esc(C.newLabel) + '</span>' : '') + '</span>' +
        '<span class="lvk__ginfo"><span class="lvk__gname">' + esc(p.title) + '</span><span class="lvk__gprice">' + price + '</span></span></a>';
    }).join('');
  }

  function recCard(p) {
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return '';
    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="lvk__sel" aria-label="' + esc(C.sizeLabel) + '"><option value="">' + esc(C.sizeLabel) + '</option>' +
        vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>';
    }
    return '<div class="lvk__rec" data-pid="' + p.id + '">' +
      '<a class="lvk__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 200)) + '" srcset="' + esc(srcset(p.image, [100, 200, 300])) + '" sizes="84px" alt="' + esc(p.title) + '" width="84" height="105" loading="eager" decoding="async">' : '') + '</a>' +
      '<div><a class="lvk__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<p class="lvk__recprice">' + esc(money(p.price)) + '</p>' + sel +
      '<button type="button" class="lvk__add" data-add="' + (vs.length === 1 ? vs[0].id : '') + '"' + (vs.length > 1 ? ' disabled' : '') + '>' + esc(C.addLabel) + '</button>' +
      '</div></div>';
  }

  function normalize(p) {
    return {
      id: p.id, title: p.title, url: p.url, price: p.price,
      image: p.featured_image || p.image || (p.images && p.images[0]) || null,
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available, price: v.price }; })
    };
  }

  function showRecs(list) {
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (i) { inCart[i.product_id] = 1; });
    var seen = {}, out = [];
    list.forEach(function (p) {
      if (!p || inCart[p.id] || seen[p.id]) return;
      seen[p.id] = 1;
      out.push(p);
    });
    out = out.slice(0, C.recsLimit || 6);
    var html = out.map(recCard).join('');
    trackEl.innerHTML = html;
    recsEl.hidden = !html;
  }

  function loadRecs() {
    var items = (cart && cart.items) || [];
    var pid = items.length ? items[0].product_id : null;
    var key = pid + ':' + items.map(function (i) { return i.product_id; }).join(',');
    if (key === recsFor) return;
    recsFor = key;
    if (!pid) { trackEl.innerHTML = ''; recsEl.hidden = true; return; }
    var base = C.rootUrl.replace(/\/$/, '') + '/recommendations/products.json?limit=10&product_id=' + pid + '&intent=';
    api(base + (C.recsIntent || 'complementary'))
      .then(function (r) {
        var list = (r.products || []).map(normalize);
        if (list.length < 2 && C.recsIntent !== 'related') {
          return api(base + 'related').then(function (r2) { return list.concat((r2.products || []).map(normalize)); });
        }
        return list;
      })
      .catch(function () { return []; })
      .then(function (list) { showRecs(list.concat(C.fallback)); });
  }

  function change(key, qty, row) {
    if (busy) return;
    busy = true;
    if (row) row.classList.add('is-busy');
    api(C.rootUrl.replace(/\/$/, '') + '/cart/change.js', { id: key, quantity: qty })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) { alertLine(row, e.message); return refresh().catch(function () {}); }) /* auch wenn das Neuladen scheitert: Sperre unten wieder lösen */
      .then(function () { busy = false; if (row) row.classList.remove('is-busy'); });
  }

  function alertLine(row, msg) {
    if (!row) return;
    var p = document.createElement('p');
    p.className = 'lvk__lindisc';
    p.style.color = '#c0392b';
    p.textContent = msg;
    row.appendChild(p);
  }

  function add(id, btn) {
    if (!id || busy) return;
    busy = true;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    api(C.rootUrl.replace(/\/$/, '') + '/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () { return refresh(); })
      .catch(function (e) { btn.textContent = e.message || t('error', 'Error'); setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200); refresh().catch(function () {}); })
      .then(function () { busy = false; });
  }

  function open() {
    if (el.classList.contains('is-open')) { refresh(); return; }
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lvk-lock');
    /* Fokus auf das Fenster (nicht aufs X) – sonst zeigt der Browser einen Rahmen um das X */
    var pnl = el.querySelector('.lvk__panel');
    if (pnl) setTimeout(function () { pnl.focus({ preventScroll: true }); }, 50);
    refresh().catch(function () { render(); });
  }

  function close() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lvk-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  el.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-lvk-close]')) { close(); return; }
    var row = t.closest('.lvk__item');
    var q = t.closest('[data-q]');
    if (q && row) {
      var cur = parseInt(row.querySelector('.lvk__qval').textContent, 10) || 1;
      change(row.getAttribute('data-key'), Math.max(0, cur + Number(q.getAttribute('data-q'))), row);
      return;
    }
    if (t.closest('[data-rm]') && row) { change(row.getAttribute('data-key'), 0, row); return; }
    var a = t.closest('[data-add]');
    if (a) {
      var rec = a.closest('.lvk__rec');
      var sel = rec && rec.querySelector('.lvk__sel');
      add(a.getAttribute('data-add') || (sel && sel.value), a);
    }
  });

  el.addEventListener('change', function (e) {
    if (e.target.classList.contains('lvk__sel')) {
      var btn = e.target.closest('.lvk__rec').querySelector('[data-add]');
      btn.disabled = !e.target.value;
      btn.setAttribute('data-add', e.target.value);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('is-open')) close();
  });

  // Theme-Drawer (Horizon) durch unseren ersetzen
  function patchDrawer(Ctor) {
    if (!Ctor || Ctor.prototype.__lvk) return;
    var p = Ctor.prototype, o = p.open, t = p.toggle;
    p.open = function () { if (this.id === 'cart-drawer') return open(); return o.apply(this, arguments); };
    p.toggle = function () {
      if (this.id === 'cart-drawer') return el.classList.contains('is-open') ? close() : open();
      return t.apply(this, arguments);
    };
    p.__lvk = true;
  }
  if (window.customElements) {
    if (customElements.get('theme-drawer')) patchDrawer(customElements.get('theme-drawer'));
    else customElements.whenDefined('theme-drawer').then(patchDrawer);
  }

  // Warenkorb-Links (z. B. /cart) abfangen
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || el.contains(a)) return;
    var h = a.getAttribute('href');
    if (h === C.cartUrl || h === '/cart') { e.preventDefault(); open(); }
  }, true);

  // Nach jedem „In den Warenkorb“ des Themes öffnen
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-Lavish-Cart'] || (init.headers.get && init.headers.get('X-Lavish-Cart')));
    var p = nativeFetch(input, init);
    if (!mine && /\/cart\/add/.test(url)) {
      p.then(function (r) {
        if (r.ok) setTimeout(function () { if (C.autoOpen) open(); else refresh(); }, 120);
      }).catch(function () {});
    } else if (!mine && /\/cart\/(change|update|clear)/.test(url)) {
      p.then(function () { if (el.classList.contains('is-open')) refresh(); }).catch(function () {});
    }
    return p;
  };

  window.LavishCart = { open: open, close: close, refresh: refresh };
  render();
})();
